// Cached icon entries are pending fetch promises or their resolved responses
// (see Icon.vue), so the value shape is opaque to this module.
const CACHE: Record<string, unknown> = {}
const EXPIRE_TIME: Record<string, number> = {}
const WAIT = 10000
const DELAY = 5000
let interval: ReturnType<typeof setInterval>
let dirty = false

export function getCache(key: string): unknown {
  setTime(key)
  return CACHE[key]
}

export function setCache(key: string, value: unknown): void {
  CACHE[key] = value
  setTime(key)

  if (!dirty) {
    initClearCache()
  }
}

function initClearCache() {
  dirty = true

  const later = () => {
    clearCache()

    if (!Object.keys(CACHE).length) {
      dirty = false
      clearInterval(interval)
    }
  }

  interval = setInterval(later, WAIT)
}

function setTime(key: string): void {
  EXPIRE_TIME[key] = Date.now() + DELAY
}

function clearCache() {
  Object.entries(EXPIRE_TIME).forEach((values) => {
    const [key, value] = values
    if (value < Date.now()) {
      delete CACHE[key]
      delete EXPIRE_TIME[key]
    }
  })
}
